import {createAsyncThunk} from '@reduxjs/toolkit';
import {getUser} from 'api/auth/auth';

export const USER_LOGOUT = 'USER_LOGOUT';

/**
 * Gets the currently authenticated user and updates the store with the user data
 *
 */
export const getUserData = createAsyncThunk(
    'user/getUserData',
    async (_, {rejectWithValue}) => {
        try {
            const response = await getUser();

            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
